import styled from 'styled-components';

export const AudioTrackContainer = styled.div`
  height: 100%;
  margin-right: 1rem;
  display: flex;

  audio {
    height: 100%;
  }
`;
